export enum NimbusPermissionAccessType {
  Read = 'Read',
  Update = 'Update',
  Create = 'Create',
  Delete = 'Delete',
}

export const AccessTypesRead: NimbusPermissionAccessType[] = [NimbusPermissionAccessType.Read];
export const AccessTypesReadUpdate: NimbusPermissionAccessType[] = [NimbusPermissionAccessType.Read, NimbusPermissionAccessType.Update];
export const AccessTypesReadUpdateCreateDelete: NimbusPermissionAccessType[] = [
  NimbusPermissionAccessType.Read,
  NimbusPermissionAccessType.Update,
  NimbusPermissionAccessType.Create,
  NimbusPermissionAccessType.Delete,
];
